module.exports = __webpack_public_path__ + "static/05-a695b446fd58d9d8bb509184ce76923e.jpg";